import { WhiteImage } from 'assets/img';
import { Constants } from 'utils';

interface Props {
  image: string;
  fallBackImage?: string;
  name: string;
  title?: string;
  description?: string;
}

const User = (props: Props) => {
  const { image, name, title, description } = props;
  return (
    <div id="container-user">
      <img
        src={Constants.BASE_STORAGE + image}
        className="image"
        onError={(e: any) => (e.target.src = WhiteImage)}
      />
      <div className="container-name">
        {title && <p className="title">{title}</p>}
        <p className="name">{name || ''}</p>
        {description && <p className="description">{description}</p>}
      </div>
    </div>
  );
};

export default User;
